(function(){
  if (window.__ES_CLICK_OPTIMIZER__) return;
  window.__ES_CLICK_OPTIMIZER__ = true;

  var TEST_ID = 'digesthe_clicks_t1';
  var START = Date.UTC(2026, 4, 3, 10, 0, 0); // 2026-05-03 12:00 Paris approx.
  var DURATION_DAYS = 2;
  var path = location.pathname || '';
  var active = path.indexOf('/pages/decouvrir-le-rituel-digesthe') === 0 || path.indexOf('/products/box-digesthe') === 0;
  if (!active) return;

  function assignVariant(){
    try {
      var key = 'es_exp_' + TEST_ID;
      var v = localStorage.getItem(key);
      if (v === 'A' || v === 'B') return v;
      var seed = (crypto && crypto.getRandomValues) ? crypto.getRandomValues(new Uint32Array(1))[0] : Math.floor(Math.random()*1000000);
      v = (seed % 2 === 0) ? 'A' : 'B';
      localStorage.setItem(key, v);
      return v;
    } catch(e) { return Math.random() < 0.5 ? 'A' : 'B'; }
  }
  var variant = assignVariant();
  window.__ES_CLICK_TEST = {id: TEST_ID, variant: variant, started_at_utc: START, duration_days: DURATION_DAYS};

  function txt(el){ return (el && el.innerText || '').replace(/\s+/g,' ').trim(); }
  function setText(el, value){ if (el && value) el.textContent = value; }
  function isDigestheCta(el){
    if (!el) return false;
    var href = el.href || '';
    var t = txt(el).toLowerCase();
    return href.indexOf('/products/box-digesthe') !== -1 || href.indexOf('/cart/49280332792145:1') !== -1 || /digesth|rituel|cure|commencer|découvrir/.test(t);
  }
  function apply(){
    if (variant !== 'B') return;
    if (path.indexOf('/pages/decouvrir-le-rituel-digesthe') === 0) {
      Array.prototype.slice.call(document.querySelectorAll('a')).forEach(function(a){
        if (isDigestheCta(a) && /digesth|installer|découvrir/i.test(txt(a))) setText(a, 'Je commence mon rituel 21 jours');
      });
    }
    if (path.indexOf('/products/box-digesthe') === 0) {
      Array.prototype.slice.call(document.querySelectorAll('button,a')).forEach(function(el){
        var t = txt(el);
        if (/^Ajouter au panier$/i.test(t)) setText(el, 'Je commence mon rituel 21 jours');
        if (/Commencer ma cure digestion 21 jours|Installer mon rituel digestif|Je découvre le rituel 21 jours/i.test(t)) setText(el, 'Je commence mon rituel 21 jours');
      });
    }
    var marker = document.createElement('div');
    marker.setAttribute('data-es-click-test', TEST_ID + ':' + variant);
    marker.style.display = 'none';
    document.documentElement.appendChild(marker);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
